import { Box, TextField, Tooltip, Typography } from '@mui/material'
import React from 'react'
import NumberInput from '../../common/NumberInput'
import { useAppDispatch, useAppSelector } from '../../../store/reducers/store'
import { updatePortfolio } from '../../../store/actions/createPortfolio'
import { useTranslation } from 'react-i18next'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const FundFeesSelection: React.FC = () => {
    const portfolio = useAppSelector(state => state.createPortfolio.portfolio);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    const onManagementFeesChanged = (event: any, value: number | undefined) => {
        dispatch(updatePortfolio({ field: "managementFees", value: value !== undefined ? value / 100 : undefined }))
    }
    const onCarryFeesChanged = (event: any, value: number | undefined) => {
        dispatch(updatePortfolio({ field: "carryFees", value: value !== undefined ? value / 100 : undefined }))
    }
    const onPortfolioLifeChanged = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        let life = event.currentTarget.value as string;
        life = life.replaceAll(/[^0-9+]/gi, '')
        dispatch(updatePortfolio({ field: "portfolioLife", value: life }))
    }
    const onMultipleAtExitChanged = (event: any, value: number | undefined) => {
        dispatch(updatePortfolio({ field: "multipleAtExit", value: value }))
    }

    return <Box display={"flex"} flexDirection={"column"} gap={"24px"}>
        <Box display={"flex"} flexDirection={"column"} gap={"12px"}>
            <Box display={"flex"} flexDirection={"row"} gap={"5px"} alignItems={"center"}>
                <Typography fontSize={"16px"} fontWeight={"500"} lineHeight={"19.5px"}>
                    {t('CreatePortfolioEnterManagementFees')}
                </Typography>
                <Tooltip title={t('LibraryOfFundsOverviewTabFeeManagementDescription')} arrow>
                    <HelpOutlineIcon fontSize='small' />
                </Tooltip>
            </Box>
            <NumberInput placeholder={t('CreatePortfolioEnterValuePC')} value={portfolio.managementFees !== undefined ? portfolio.managementFees * 100 : undefined} onChange={onManagementFeesChanged} />
        </Box>
        <Box display={"flex"} flexDirection={"column"} gap={"12px"}>
            <Box display={"flex"} flexDirection={"row"} gap={"5px"} alignItems={"center"}>
                <Typography fontSize={"16px"} fontWeight={"500"} lineHeight={"19.5px"}>
                    {t('CreatePortfolioEnterCarryFees')}
                </Typography>
                <Tooltip title={t('LibraryOfFundsOverviewTabFeeCarryDescription')} arrow>
                    <HelpOutlineIcon fontSize='small' />
                </Tooltip>
            </Box>
            <NumberInput placeholder={t('CreatePortfolioEnterValuePC')} value={portfolio.carryFees !== undefined ? portfolio.carryFees * 100 : undefined} onChange={onCarryFeesChanged} />
        </Box>
        <Box display={"flex"} flexDirection={"column"} gap={"12px"}>
            <Box display={"flex"} flexDirection={"row"} gap={"5px"} alignItems={"center"}>
                <Typography fontSize={"16px"} fontWeight={"500"} lineHeight={"19.5px"}>
                    {t('CreatePortfolioEnterExpectedPortfolioLife')}
                </Typography>
                <Tooltip title={t('LibraryOfFundsOverviewTabFeeFundLifeDescription')} arrow>
                    <HelpOutlineIcon fontSize='small' />
                </Tooltip>
            </Box>
            <TextField placeholder={t('CreatePortfolioEnterValueLife')} onChange={onPortfolioLifeChanged} value={portfolio.portfolioLife} />
        </Box>
        <Box display={"flex"} flexDirection={"column"} gap={"12px"}>
            <Box display={"flex"} flexDirection={"row"} gap={"5px"} alignItems={"center"}>
                <Typography fontSize={"16px"} fontWeight={"500"} lineHeight={"19.5px"}>
                    {t('CreatePortfolioEnterMultipleAtPortfolioExit')}
                </Typography>
                <Tooltip title={t('CreatePortfolioMultipleAtPortfolioExitDescription')} arrow>
                    <HelpOutlineIcon fontSize='small' />
                </Tooltip>
            </Box>
            <NumberInput placeholder={t('CreatePortfolioEnterValue')} value={portfolio.multipleAtExit} onChange={onMultipleAtExitChanged} />
        </Box>
    </Box>
}

export default FundFeesSelection